var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.pieChartData),function(pieData,i){return _c('v-col',{key:i},[_c('v-container',{staticClass:"outlined",attrs:{"rounded":"","white":""}},[_c('pie-chart',{attrs:{"chart-data":pieData,"options":_vm.pieChartOptions(pieData.title),"width":300,"align":"center"}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }